<template>
  <div>
    <el-form ref="questionnaire" label-position="left" :model="questionnaire">
      <el-row
        type="flex"
        align="top"
        :gutter="10"
        v-for="(item, index) in questionnaire.questionnaires"
        :key="index"
      >
        <el-col :span="4">
          <div class="questionnaire-div">{{ index + 1 }}</div>
        </el-col>
        <el-col :span="20">
          <el-form-item>
            <div slot="label">
              <span class="wordWrap questionnaire-label">{{ item.question }}</span>
            </div>
            <el-input  :disabled="true" type="textarea" v-model="item.answer"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    formLabelAlign: {
      type: Object,
      default: function () {},
    },
  },
  watch: {
    formLabelAlign: {
      handler(v) {
        if (v !== null) {
          this.questionnaire.questionnaires = JSON.parse(
          this.componentMethods(v.components, 4)
          );
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      questionnaire: {
        questionnaires: [
          {
            question:
              "申請人是否對音樂、體育或其他方面有濃厚興趣或才能?\nDoes the applicant have strong interests or talents in music, sports, etc? ",
            answer: "",
          },
          {
            question:
              "申請人是否在社會服務或社區工作上有任何經驗?\nDoes the applicant have any experience of social service or community work?  ",
            answer: "",
          },
          {
            question:
              "請形容申請人三個性格上的優點。\nGive three features that best describe the applicant’s character. ",
            answer: "",
          },
          {
            question:
              "申請人期望在本校就讀香港中學文憑課程學到甚麼? \nWhat does the applicant expect to learn from our school during the study of the HKDSE Programme?  ",
            answer: "",
          },
          {
            question:
              "申請人是否有特殊教育需要? 如有，請說明。\nDoes the applicant have any special educational needs? If yes, please specify.  ",
            answer: "",
          },
          {
            question:
              "申請人理想的職業是甚麼? \nWhat is the applicant’s ideal career aspiration? ",
            answer: "",
          },
          {
            question:
              "如有任何其他資料補充，請在此填寫。\nGive any other information or comments which may be useful.",
            answer: "",
          },
        ],
      },
    };
  },
  methods: {
    componentMethods(components, type) {
      return components.filter((v) => {
        return v.type == type;
      })[0].value;
    },
  },
};
</script>

<style lang="scss" scoped>
.questionnaire-div {
  //正方形
  width: 30px;
  height: 30px;
  background-color: #409eff;
  border-radius: 6px;
  //文字
  font-size: 20px;
  color: #fff;
  text-align: center;
  line-height: 30px;
}
.el-button--primary{
  width: auto;
}
@media (min-width: $phoneMinWidth) and (max-width: $phoneMaxWidth) {
  ::v-deep{
    .el-form-item__label{
      line-height: 1.4375rem;
      margin-bottom: 0.625rem;
        white-space:pre-wrap;
        word-wrap:break-word;
        word-break:keep-all;
        word-wrap:break-word;
         overflow-wrap: break-word;
         width: 100%;
    }
  }
  .from-button-group .el-button{
    margin-bottom: 0.625rem;
  }
  .from-button-group .el-button{
    margin-left: 0;
  }
}
</style>